module.exports = __webpack_public_path__ + "img/merge-p4.4a25f017.jpg";